import React from "react";

export type SpinnerContainerProps = React.AllHTMLAttributes<HTMLDivElement> & {
  height?: string;
};

export const SpinnerContainer = ({ height, children, className }: SpinnerContainerProps) => {
  const styling = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    height: height || "100%",
  } as React.CSSProperties;

  return (
    <div style={styling} className={className}>
      {children}
    </div>
  );
};
